module.exports = __webpack_public_path__ + "img/water02.c8320696.jpg";